import mutations from './dashboard.mutations'
import actions from './dashboard.actions'
import getters from './dashboard.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
